@if (selectedDatasource) {
  <div>
    {{ selectedDatasource.name }}
  </div>
}
<div class="container">
  <mat-list>
    @for (client of availableClients; track client) {
      <div
        id="client-datasource-collection"
        >
        <div matSubheader>{{ client.name }}</div>
        <mat-divider></mat-divider>
        @for (datasource of datasourcesForClient(client); track datasource) {
          <mat-list-item
            (click)="editOrCreateDataSource(datasource)"
            >
            <mat-icon matListItemIcon>file_present</mat-icon>
            <div matListItemTitle>{{ datasource.name }}</div>
          </mat-list-item>
        }
      </div>
    }
  </mat-list>

  <div class="justify-content-center d-flex">
    <div class="add-report-button d-flex flex-row align-items-center">
      <div class="p-2 button-text">Datenquelle hinzufügen</div>
      <button
        class="ml-auto"
        mat-fab
        color="primary"
        aria-label="Element hinzufügen"
        (click)="editOrCreateDataSource(null)"
        >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
</div>
